<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    :width="width"
    :height="height"
  >
    <path d="M30 23.0005H29V7.23798L30.2087 6.97798C30.3399 6.95338 30.4649 6.90276 30.5762 6.82911C30.6875 6.75546 30.783 6.66027 30.8569 6.54915C30.9309 6.43803 30.9818 6.31323 31.0068 6.18211C31.0317 6.05098 31.0302 5.91619 31.0022 5.78567C30.9743 5.65516 30.9205 5.53156 30.844 5.42216C30.7675 5.31276 30.6699 5.21979 30.5569 5.14871C30.444 5.07762 30.3179 5.02988 30.1862 5.00829C30.0545 4.9867 29.9198 4.99169 29.79 5.02298L1.79 11.023C1.54878 11.075 1.33533 11.2144 1.19069 11.4144C1.04606 11.6143 0.980465 11.8607 1.00652 12.1061C1.03258 12.3515 1.14846 12.5786 1.33186 12.7437C1.51526 12.9088 1.75323 13.0002 2 13.0005C2.07101 13.0004 2.14181 12.9928 2.21125 12.978L3 12.8092V23.0005H2C1.73478 23.0005 1.48043 23.1058 1.29289 23.2934C1.10536 23.4809 1 23.7353 1 24.0005C1 24.2657 1.10536 24.5201 1.29289 24.7076C1.48043 24.8951 1.73478 25.0005 2 25.0005H30C30.2652 25.0005 30.5196 24.8951 30.7071 24.7076C30.8946 24.5201 31 24.2657 31 24.0005C31 23.7353 30.8946 23.4809 30.7071 23.2934C30.5196 23.1058 30.2652 23.0005 30 23.0005ZM5 12.3755L27 7.66673V23.0005H24V16.0005C24 15.7353 23.8946 15.4809 23.7071 15.2934C23.5196 15.1058 23.2652 15.0005 23 15.0005H9C8.73478 15.0005 8.48043 15.1058 8.29289 15.2934C8.10536 15.4809 8 15.7353 8 16.0005V23.0005H5V12.3755ZM22 19.0005H10V17.0005H22V19.0005ZM10 21.0005H22V23.0005H10V21.0005Z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>

